// extracted by mini-css-extract-plugin
module.exports = {"panicBtnIcon":"PanicButton_panicBtnIcon__3U-uq","panicBtnContainer":"PanicButton_panicBtnContainer__2vHvl"};